import {Box, Typography} from '@mui/material';
import {useMemo, useState} from 'react';

export const Expandable = ({
  description,
  title,
  maxCharacter = 220,
  expandLabel = 'Read More',
  compressLabel = 'Read Less',
  normalTextExpand = false,
  actionTextColor = 'primary',
  sx,
}: {
  description: string;
  title?: string;
  maxCharacter?: number;
  expandLabel?: string;
  compressLabel?: string;
  normalTextExpand?: boolean;
  actionTextColor?: string;
  sx?: object;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(exp => !exp);
  };

  const componentDescription = useMemo(() => {
    const isExpandable = description.length > maxCharacter;

    let finalDescription = description;
    if (!isExpanded && isExpandable) {
      finalDescription = finalDescription.slice(0, maxCharacter);
      finalDescription = finalDescription.replace('\n', '');
    }

    const descriptionLines = finalDescription.split('\n');
    return descriptionLines.map((line: string, index: number) => {
      const isLastLine = index === descriptionLines.length - 1;

      return (
        <Typography key={index} lineHeight={'18px'} component={'p'} sx={sx}>
          {line}
          {isLastLine && isExpandable && (
            <>
              {isExpanded ? '  ' : '...'}
              <Typography
                component={'span'}
                color={actionTextColor}
                onClick={toggleExpansion}
                sx={{
                  cursor: 'pointer',
                  ml: normalTextExpand ? 0.5 : 1,
                  ...sx,
                }}
              >
                {!isExpanded ? expandLabel : compressLabel}
              </Typography>
            </>
          )}
        </Typography>
      );
    });
  }, [isExpanded]);

  if (normalTextExpand) {
    return <>{componentDescription}</>;
  }

  return (
    <Box sx={{backgroundColor: '#F3F7FA', p: 1, borderRadius: 2}}>
      <Box px={1} fontWeight={500} fontSize={12} pb={1}>
        <Typography fontSize={12}>{title || 'Expansion Title'}</Typography>
      </Box>
      <Box sx={{backgroundColor: '#fff', borderRadius: 2}} p={1}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          {componentDescription}
        </Box>
      </Box>
    </Box>
  );
};

export default Expandable;
